export enum CartStatus {
    PENDING = 'PENDING',
    ON_SALE = 'ON_SALE',
    SOLD_OUT = 'SOLD_OUT',
    DISCONTINUED = 'DISCONTINUED',
}
